@if (displayedColumns | includes: 'status') {
  <div class="status-container">
    @if (company.initializationInProgress || company.mission?.endDate || company.mission.worksStop) {
      <app-company-status
        [initializationInProgress]="company.initializationInProgress"
        [mission]="company.mission"
      ></app-company-status>
    }
  </div>
}

@if (displayedColumns | includes: 'company') {
  <app-company-cell [company]="company"></app-company-cell>
}

@if (displayedColumns | includes: 'contacts') {
  @if (company.users.length > 0) {
    <app-company-users-contacts [contacts]="company.users"></app-company-users-contacts>
  }
}

@if (displayedColumns | includes: 'overviewButton') {
  <button
    #overviewAnchor
    class="overview-action"
    tiime-button
    icon
    color="primary"
    tiimeTooltip="Fiche dossier"
    (click)="$event.stopPropagation(); openCompanyOverview()"
  >
    <mat-icon svgIcon="icon-id-card"></mat-icon>
  </button>
}

@if (displayedColumns | includes: 'openInNewTab') {
  <button
    tiime-button
    icon
    color="primary"
    tiimeTooltip="Ouvrir dans un nouvel onglet"
    (click)="$event.stopPropagation(); openInNewTab()"
  >
    <mat-icon>open_in_new</mat-icon>
  </button>
}
